import type { ReactNode } from "react";
import classNames from "classnames";

export interface ListWrapperProps {
  children: ReactNode;
  className?: string;
  hasBorder?: boolean;
}

export const ListWrapper = ({
  hasBorder = true,
  children,
  className,
}: ListWrapperProps) => (
  <div
    className={classNames("bg-primary px-6", className, {
      "border-primary border-b": hasBorder,
    })}
  >
    {children}
  </div>
);
